import { render, staticRenderFns } from "./TeacherLayout.vue?vue&type=template&id=4f2d2b70&scoped=true"
import script from "./TeacherLayout.vue?vue&type=script&lang=js"
export * from "./TeacherLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2d2b70",
  null
  
)

export default component.exports